import React, { useEffect, useState } from "react";
import { InfoTip } from "@/components/InfoTip";
import { toast } from "sonner";
import { FileText, Download, RefreshCw, Loader2 } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";

const err = (e) => toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message);

export function CoachingDokuCard({ clientId }) {
  const [meta, setMeta] = useState(null);
  const [busy, setBusy] = useState("");
  const load = () => api.get(`/clients/${clientId}/coaching-doku`).then((r) => setMeta(r.data)).catch(() => setMeta({}));
  useEffect(() => { load(); }, [clientId]); // eslint-disable-line react-hooks/exhaustive-deps
  const open = async () => {
    const win = window.open("", "_blank");
    setBusy("open");
    try {
      const r = await api.get(`/clients/${clientId}/coaching-doku.pdf`, { responseType: "blob" });
      win.location.href = URL.createObjectURL(new Blob([r.data], { type: "application/pdf" }));
      load();
    } catch (e) { win?.close(); err(e); } finally { setBusy(""); }
  };
  const regen = async () => {
    setBusy("regen");
    try { const r = await api.post(`/clients/${clientId}/coaching-doku`); setMeta(r.data); toast.success("Coaching-Dokumentation aktualisiert"); }
    catch (e) { err(e); } finally { setBusy(""); }
  };
  if (!meta) return null;
  return (
    <div className="border border-slate-200 bg-white p-4 flex flex-wrap items-center gap-3" data-testid="coaching-doku-card">
      <FileText size={16} className="text-[#0a788c]" />
      <div className="flex-1 min-w-[200px]">
        <div className="text-sm font-medium text-slate-900 flex items-center gap-2">Coaching-Dokumentation <InfoTip k="coaching-doku" /></div>
        <div className="text-xs text-slate-500" data-testid="coaching-doku-status">
          {meta.generated_at
            ? `Stand ${new Date(meta.generated_at).toLocaleString("de-DE", { dateStyle: "short", timeStyle: "short" })} · ${meta.entries} Termine · ${Number(meta.total_ue || 0).toLocaleString("de-DE")} UE · wird nach jeder Unterschrift automatisch aktualisiert`
            : "Wird nach der ersten Termin-Unterschrift automatisch erstellt."}
        </div>
      </div>
      <button onClick={regen} disabled={!!busy} className="inline-flex items-center gap-1 border border-slate-300 px-2.5 py-1 text-xs hover:bg-slate-50 disabled:opacity-50" data-testid="coaching-doku-regenerate">
        {busy === "regen" ? <Loader2 size={11} className="animate-spin" /> : <RefreshCw size={11} />} Neu erstellen
      </button>
      <button onClick={open} disabled={!!busy} className="inline-flex items-center gap-1 bg-slate-900 text-white px-2.5 py-1 text-xs hover:bg-slate-800 disabled:opacity-50" data-testid="coaching-doku-download">
        {busy === "open" ? <Loader2 size={11} className="animate-spin" /> : <Download size={11} />} PDF herunterladen
      </button>
    </div>
  );
}
